// TODO: Implementar la funcionalidad con los metacampos de la lista de productos. 

function capitalize(str) {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/\//g, ' / ')
    .split(/\s+/)
    .filter(word => word.length > 0)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

document.addEventListener('DOMContentLoaded', function () {
  const variantColors = document.querySelectorAll('.container-variant-color .variant-color');
  const containerVariants = document.querySelectorAll('.container-variant-color');
  const titleVariant = document.getElementById('title-variant');
  const titleVariantSpan = titleVariant?.querySelector('span');

  function getActiveColorName() {
    let activeSwatch = null;
    document.querySelectorAll('.container-variant-color').forEach(c => {
      const found = c.querySelector('.variant-color-swatch.active .variant-color');
      if (found) activeSwatch = found;
    });
    const source = activeSwatch || null;
    const colorCode = source?.getAttribute('data-color') || titleVariant?.getAttribute('data-color');
    if (!colorCode) return '';
    return source?.getAttribute('data-name-color') || titleVariant?.getAttribute('data-name-color') || '';
  }

  if (variantColors.length > 0 && titleVariantSpan) {
    variantColors.forEach(element => {
      element.addEventListener('mouseover', function () {
        const colorCode = this.getAttribute('data-color');
        if (!colorCode) {
          titleVariantSpan.textContent = '';
          return;
        }
        const colorName = this.getAttribute('data-name-color');
        titleVariantSpan.textContent = capitalize(colorName);
      });
    });

    containerVariants.forEach(container => {
      container.addEventListener('mouseleave', function () {
        const colorName = getActiveColorName();
        titleVariantSpan.textContent = capitalize(colorName);
      });
    });
  }

  // Prevent navigation when clicking the active color swatch
  document.querySelectorAll('.variant-color-swatch.active a.card-item-family').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
    });
  });

  // When a size radio is selected, toggle disabled on color swatches (related products)
  function updateSwatchAvailability(selectedSize) {
    document.querySelectorAll('.variant-color-swatch[data-available-sizes]').forEach(swatch => {
      const sizes = swatch.dataset.availableSizes.split(',').map(s => s.trim()).filter(s => s.length > 0);
      if (sizes.includes(selectedSize)) {
        swatch.classList.remove('disabled');
      } else {
        swatch.classList.add('disabled');
      }
    });
  }

  // Event delegation: survives DOM re-renders of variant-selects
  document.addEventListener('change', function (e) {
    if (e.target.matches('.product-form__input--pill input[type="radio"]')) {
      updateSwatchAvailability(e.target.value);
    }
  });

  // After server confirms variant availability, update active swatch accordingly
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
      const activeSwatch = document.querySelector('.variant-color-swatch.active[data-available-sizes]');
      if (!activeSwatch) return;
      if (!variant || !variant.available) {
        activeSwatch.classList.add('disabled');
      } else {
        activeSwatch.classList.remove('disabled');
      }
    });
  }

  // Toggle store-check icon on each swatch based on localStorage store match
  (function updateStoreIcons() {
    let userStore = null;
    try {
      userStore = JSON.parse(localStorage.getItem('locationUserSettings'))?.store;
    } catch (e) {}

    document.querySelectorAll('.variant-color-swatch[data-store-locations]').forEach(swatch => {
      const locations = swatch.dataset.storeLocations.split(',').map(s => s.trim()).filter(s => s.length > 0);
      const iconDefault = swatch.querySelector('.kt-icon--store-check-default');
      const iconActive = swatch.querySelector('.kt-icon--store-check-active');
      const isActive = swatch.classList.contains('active');
      const storeMatch = userStore && locations.includes(userStore);

      if (isActive) {
        // Active swatch uses kt-icon--store-check-active (CSS hides default on .active)
        if (iconActive) iconActive.style.display = storeMatch ? 'block' : 'none';
        if (iconDefault) iconDefault.style.display = 'none';
      } else {
        // Non-active swatches use kt-icon--store-check-default
        if (iconDefault) iconDefault.style.display = storeMatch ? 'block' : 'none';
        if (iconActive) iconActive.style.display = 'none';
      }
    });
  })();

  // Populate color in price variant info section
  const priceColorSpan = document.querySelector('.price-variant-info__color');
  const priceColorLine = document.querySelector('.price-variant-info__color-line');
  if (priceColorSpan && priceColorLine) {
    const activeColor = getActiveColorName();
    if (activeColor) {
      priceColorSpan.textContent = capitalize(activeColor);
      priceColorLine.style.display = '';
    }
  }
});
